import { DependencyList, useEffect } from "react";

export function useAsyncEffect(effect: () => Promise<void>, deps?: DependencyList) {
  return useEffect(() => {
    (async () => {
      await effect();
    })();
  }, deps);
}

export function loremIpsum(len = 1e3, char = "?") {
  return Array<string>(~~(Math.random() * len + len) >> 1)
    .fill(char)
    .join("");
}

export function downloadJsonAsCsv(jsonData: any[], fileName: string) {
  const convertJsonToCsv = (jsonData: any[]): string => {
    const separator = ",";
    const keys = Object.keys(jsonData[0]);
    let csvContent = keys.join(separator) + "\n";

    for (const item of jsonData) {
      const values = keys.map((key) => item[key]);
      const row = values.map((value) => escapeCsvValue(value)).join(separator);
      csvContent += row + "\n";
    }

    return csvContent;
  };

  const escapeCsvValue = (value: any): string => {
    if (typeof value === "string") {
      if (value.includes(",") || value.includes('"') || value.includes("\n")) {
        return '"' + value.replace(/"/g, '""') + '"';
      }
      return value;
    }

    if (typeof value === "undefined" || value === null) {
      return "";
    }

    return String(value);
  };

  const csvData = convertJsonToCsv(jsonData);
  const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
